module.exports = __webpack_public_path__ + "static/media/about-certificate-img13.d5afa39b.jpg";